import { create } from "apisauce";
import axios from 'axios';
import { AUTH_TOKEN } from "constants/SiteConstants";
import { API_BASE_URL } from "configs/AppConfig";

const authHeader = () => {
  let token = localStorage.getItem(AUTH_TOKEN);
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const api = create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 300000,
});

const get = async (url, data) => api.get(url, data, { headers: authHeader() });

const post = (url, data) => api.post(url, data, { headers: authHeader() });

const put = (url, data) => api.put(url, data, { headers: authHeader() });

const del = (url) => api.delete(url, {}, { headers: authHeader() });

const download = (url, data) => {
  const options = {
    method: 'GET',
    headers: authHeader(),
    responseType: 'blob',
    url: API_BASE_URL + url,
    params: data
  };
  return axios(options)
}

export default { get, post, del, put, download };
